/* import __COLOCATED_TEMPLATE__ from './early-stage-extension-gift-banner.hbs'; */
/* RESPONSIBLE TEAM: team-frontend-tech */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import moment from 'moment-timezone';
import type BannerDismissalService from 'embercom/services/banner-dismissal-service';
import { restartableTask } from 'ember-concurrency-decorators';
import { tracked } from '@glimmer/tracking';
import { taskFor } from 'ember-concurrency-ts';

interface Args {}

export default class EarlyStageExtensionGiftBanner extends Component<Args> {
  @service declare appService: $TSFixMe;
  @service declare permissionsService: $TSFixMe;
  @service declare bannerDismissalService: BannerDismissalService;
  @service declare intercomEventService: $TSFixMe;
  @tracked shouldShowBanner = false;
  dismissalKey = 'early-stage-extension-gift-banner';

  constructor(owner: unknown, args: any) {
    super(owner, args);
    taskFor(this.computeVisibility).perform();
  }

  get app() {
    return this.appService.app;
  }

  get formattedGraduationDate() {
    let graduationDate = moment.utc(this.app?.earlyStageGraduationDate);
    return graduationDate.format('MMMM D, YYYY');
  }

  @restartableTask
  *computeVisibility() {
    let adminDismissedBanner: boolean = yield this.bannerDismissalService.hasDismissed(
      this.dismissalKey,
    );
    let adminHasBillingPermission = this.permissionsService.currentAdminCan(
      'can_access_billing_settings',
    );

    this.shouldShowBanner =
      !adminDismissedBanner && adminHasBillingPermission && this.app?.shouldSeeUsageBasedGiftBanner;

    if (this.shouldShowBanner) {
      this.intercomEventService.trackAnalyticsEvent({
        action: 'viewed',
        object: 'usage_based_gift_banner',
        context: this.dismissalKey,
      });
    }
  }

  @restartableTask
  *handleDismissClick() {
    this.shouldShowBanner = false;
    this.intercomEventService.trackAnalyticsEvent({
      action: 'dismissed',
      object: 'usage_based_gift_banner',
      context: this.dismissalKey,
    });
    yield this.bannerDismissalService.dismiss(this.dismissalKey);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Banners::EarlyStageExtensionGiftBanner': typeof EarlyStageExtensionGiftBanner;
    'banners/early-stage-extension-gift-banner': typeof EarlyStageExtensionGiftBanner;
  }
}
